module.exports = __webpack_public_path__ + "b194c0eb0677537351aed8ee362ae482.jpg";